import { Dialog, DialogContent, Typography, DialogActions, Button, DialogTitle } from "@mui/material";
import { useState } from "react";
import { Action } from "../util/func";

export function YesNoDialog({ opened, title, text, onSubmit }: { opened: boolean; title: string; text: string; onSubmit: (value: boolean) => void }) {
  return (
    <Dialog open={opened} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography whiteSpace="pre-wrap">{text}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSubmit(false)}>いいえ</Button>
        <Button onClick={() => onSubmit(true)}>はい</Button>
      </DialogActions>
    </Dialog>
  );
}

export type useYesNoDialogArgs = { title: string; text: string; onSubmit: Action<boolean> };

export function useYesNoDialog() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [onSubmit, setOnSubmit] = useState<Action<boolean>>();

  const dialog = (
    <YesNoDialog
      opened={open}
      title={title}
      text={text}
      onSubmit={(v) => {
        setOpen(false);
        if (onSubmit) {
          onSubmit(v);
        }
      }}
    />
  );
  const show = (args: useYesNoDialogArgs) => {
    setOpen(true);
    setTitle(args.title);
    setText(args.text);
    setOnSubmit(() => args.onSubmit);
  };

  return { dialog, show };
}